import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Box, Button, Checkbox, Column, IconButton, Popover, Row, Typography } from 'seagull';
import { CloseCross } from 'seagull/icons/essentials';
import { getTestIds } from 'seagull/utils/TestIds';
import { FilterChip } from '~/pages/DraftsDashboard/DraftsAiSearch/DraftsAiSearchChips/FilterChip/FilterChip';
import { isExcludeMode, valueLabelFor } from './SetPredicateChip.utils';
export const GetSetPredicateChipTID = (parentTestId)=>getTestIds(parentTestId);
export const SetPredicateChip = (param)=>{
    let { testId, fieldLabel, options, predicate, onChange, isText, isNotText, applyText, selectAllText, biPrefix } = param;
    var _predicate_nin, _predicate_in;
    const { SetPredicateChipTestIds } = useMemo(()=>GetSetPredicateChipTID(testId), [
        testId
    ]);
    const [anchorEl, setAnchorEl] = useState(null);
    const isExclude = isExcludeMode(predicate);
    const initialValues = isExclude ? (_predicate_nin = predicate.nin) !== null && _predicate_nin !== void 0 ? _predicate_nin : [] : (_predicate_in = predicate.in) !== null && _predicate_in !== void 0 ? _predicate_in : [];
    const [draftValues, setDraftValues] = useState(initialValues);
    const openPopover = (event)=>{
        setDraftValues(initialValues);
        setAnchorEl(event.currentTarget);
    };
    const closePopover = ()=>setAnchorEl(null);
    const toggleOption = (value)=>setDraftValues((current)=>current.includes(value) ? current.filter((entry)=>entry !== value) : [
                ...current,
                value
            ]);
    const allSelected = options.length > 0 && draftValues.length === options.length;
    const toggleAll = ()=>setDraftValues(allSelected ? [] : options.map((option)=>option.value));
    const toggleOperator = ()=>onChange(isExclude ? {
            in: predicate.nin
        } : {
            nin: predicate.in
        });
    const apply = ()=>{
        if (draftValues.length === 0) {
            onChange(undefined);
        } else {
            onChange(isExclude ? {
                nin: [
                    ...draftValues
                ]
            } : {
                in: [
                    ...draftValues
                ]
            });
        }
        closePopover();
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FilterChip, {
                testId: testId,
                fieldLabel: fieldLabel,
                operator: {
                    label: isExclude ? isNotText() : isText(),
                    onToggle: toggleOperator,
                    biName: "".concat(biPrefix, "_operator")
                },
                valueLabel: valueLabelFor(options, predicate, fieldLabel),
                onValueClick: openPopover,
                onFieldClick: openPopover,
                onRemove: ()=>onChange(undefined),
                removeBiName: "".concat(biPrefix, "_remove")
            }),
            /*#__PURE__*/ _jsx(Popover, {
                testId: SetPredicateChipTestIds.EditPopover(),
                open: anchorEl != null,
                anchorEl: anchorEl,
                onClose: closePopover,
                children: /*#__PURE__*/ _jsx(Box, {
                    padding: 12,
                    children: /*#__PURE__*/ _jsxs(Column, {
                        gap: 8,
                        children: [
                            /*#__PURE__*/ _jsxs(Row, {
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 16,
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "paragraph1",
                                        weight: "bold",
                                        children: fieldLabel
                                    }),
                                    /*#__PURE__*/ _jsx(IconButton, {
                                        testId: SetPredicateChipTestIds.CloseButton(),
                                        bi: {
                                            name: "".concat(biPrefix, "_close")
                                        },
                                        onClick: closePopover,
                                        size: "small",
                                        children: /*#__PURE__*/ _jsx(CloseCross, {
                                            size: 10
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Checkbox, {
                                testId: SetPredicateChipTestIds.SelectAll(),
                                bi: {
                                    name: "".concat(biPrefix, "_select_all")
                                },
                                checked: allSelected,
                                onChange: toggleAll,
                                label: selectAllText
                            }),
                            options.map((option)=>/*#__PURE__*/ _jsx(Checkbox, {
                                    testId: SetPredicateChipTestIds.Option(option.value),
                                    bi: {
                                        name: "".concat(biPrefix, "_option")
                                    },
                                    checked: draftValues.includes(option.value),
                                    onChange: ()=>toggleOption(option.value),
                                    label: option.label
                                }, option.value)),
                            /*#__PURE__*/ _jsx(Button, {
                                testId: SetPredicateChipTestIds.ApplyButton(),
                                bi: {
                                    name: "".concat(biPrefix, "_apply")
                                },
                                onClick: apply,
                                fluid: true,
                                children: applyText
                            })
                        ]
                    })
                })
            })
        ]
    });
};
